import Expertise from "gatsby-theme-dettol/src/components/Expertise/Expertise"

import "./ExpertiseOverride.scss"

export default Expertise